import { render, staticRenderFns } from "./BannerHomepage.vue?vue&type=template&id=2273d3b1&"
import script from "./BannerHomepage.vue?vue&type=script&lang=js&"
export * from "./BannerHomepage.vue?vue&type=script&lang=js&"
import style0 from "./BannerHomepage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports